export async function MountComboChart(props: any, el: Element) {
	const module = await import('./chart');
	module.MountComboChart(props, el);
}

(window as any).MountComboChart = MountComboChart;
